import { InsightsAnalysisType } from '~/views/dashboard/my-assets-widget/assets-table/utils';

export const METHOD_SUB_CLS_GROUPING: Record<string, InsightsAnalysisType> = {
  EntryPoint: InsightsAnalysisType.Technical,
  Valuations: InsightsAnalysisType.Fundamental,
  Positioning: InsightsAnalysisType.Technical,
  Momentum: InsightsAnalysisType.Technical,
  LeadingIndicator: InsightsAnalysisType.Fundamental,
  MarketData: InsightsAnalysisType.Technical,
  VolumeAnalysis: InsightsAnalysisType.Technical,
  EquityGrowthGauge: InsightsAnalysisType.Fundamental,
  EquityConsensusTrend: InsightsAnalysisType.Fundamental,
  EconomicGrowthGauge: InsightsAnalysisType.Macro,
  EconomicInflationGauge: InsightsAnalysisType.Macro,
  FinancialConditions: InsightsAnalysisType.Macro,
  Volatility: InsightsAnalysisType.Technical,
  PriceLevel: InsightsAnalysisType.Technical,
  MainYield: InsightsAnalysisType.Technical,
  GroupTechnicalAnalysis: InsightsAnalysisType.Technical,
  Geopolitical: InsightsAnalysisType.Macro,
  Sentiment: InsightsAnalysisType.Technical,
  Seasonality: InsightsAnalysisType.Technical,
  EquityYield: InsightsAnalysisType.Fundamental,
  Event: InsightsAnalysisType.Fundamental,
  TechAnalysis: InsightsAnalysisType.Technical,
  OnChainMetrics: InsightsAnalysisType.Fundamental,
};
